module.exports = __webpack_public_path__ + "static/servidores-exclusivos-f74d708e6ce580329ac92491107f97f0.png";